const TaxRollAdjustmentsListHeader = [
  {
    text: 'Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxId',
    sortable: false,
  },
  {
    text: 'SD',
    value: 'schoolDistrict',
    sortable: false,
  },
  {
    text: 'Date',
    value: 'adjDate',
    formatter: 'shortDate',
    sortable: false,
  },
  {
    text: 'Adj/Upd',
    value: 'adjOrUpd',
    sortable: false,
  },
  {
    text: 'Type',
    value: 'type',
    sortable: false,
  },
  {
    text: 'Cert #',
    value: 'certNumber',
    sortable: false,
  },
  {
    text: 'Penalty',
    value: 'penaltyVal',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Tax Amount',
    value: 'taxAmt',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Posted',
    value: 'posted',
    sortable: false,
    formatter: 'flagToYorEmpty',
  },
];

const StatusCodesHeaderTwo = [
  {
    text: 'Status',
    value: 'code',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Description',
    value: 'desc',
    align: 'center',
    sortable: false,
  },
];

export { TaxRollAdjustmentsListHeader, StatusCodesHeaderTwo };
